import { useState } from "react";
import {
  Dialog,
  DialogTrigger,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { BasicTooltip } from "@/components/ui/Tooltip";
import { Info } from "lucide-react";
import { Button } from "@/components/ui/button";

const SPECIAL_OPTIONS = [
  {
    input: "json schema",
    output: "{ type: 'json_schema' }",
  },
  {
    input: "json",
    output: "{ type: 'json_object' }",
  },
  {
    input: "text",
    output: "{ type: 'text' }",
  },
  {
    input: "none",
    output: "null",
  },
];

export const AddNewOptionsInfoDialog = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  return (
    <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
      <DialogTrigger onClick={() => setIsDialogOpen(true)} asChild>
        <div>
          <BasicTooltip content="Learn about special dropdown options">
            <Button variant="link" className="h-auto p-0 text-xs font-normal">
              Learn More
            </Button>
          </BasicTooltip>
        </div>
      </DialogTrigger>
      <DialogContent className="w-full max-w-[550px] text-sm">
        <DialogHeader>
          <DialogTitle>Special Dropdown Options</DialogTitle>
        </DialogHeader>
        <div className="flex flex-col px-1">
          <div>
            <p className="mb-2">
              Add simple categorical options such as "high", "medium", "low"
              here.
            </p>
          </div>
          <div>
            <div className="mb-2">
              For models that support response formatting, we have special
              predefined options. Use the preview to examine how these special
              cases behave.
            </div>
            <ul className="space-y-2">
              {SPECIAL_OPTIONS.map((option) => (
                <li key={option.input} className="flex items-center gap-3 pl-4">
                  <Info className="h-4 w-4 text-blue-500" />
                  <div className="flex w-full gap-2">
                    <span className="font-medium">{option.input}</span>
                    <span className="hidden text-muted-foreground sm:inline">
                      →
                    </span>
                    <code className="ml-auto rounded bg-muted px-1.5 py-0.5 font-mono text-xs sm:ml-0">
                      {option.output}
                    </code>
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <DialogFooter>
          <Button onClick={() => setIsDialogOpen(false)} type="button">
            Got it!
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
